import axios from "axios";
import {
  getPlansUrl,
  getMySubscriptionUrl,
  createPaymentOrderUrl,
  verifyPaymentUrl,
} from "../utils/urls";

export const getPlans = async () => {
  const res = await axios.get(getPlansUrl);
  return res?.data?.data;
};

export const getMySubscription = async () => {
  const res = await axios.get(getMySubscriptionUrl);
  return res?.data?.data;
};

export const createPaymentOrder = async (subscription_id) => {
  const res = await axios.post(createPaymentOrderUrl, { subscription_id });
  return res?.data?.data;
};

export const verifyPayment = async (payload) => {
  const res = await axios.post(verifyPaymentUrl, payload);
  return res?.data?.data;
};

// Load Razorpay checkout.js once.
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
